module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-henkel-3-4e99f6eb6f7e599ef885722ff296b0db.jpg";